import axios from '@/libs/api.request'

export const createPartCostOpChangeState = (id, data) => {
  return axios.request({
    url: `operation-change-states/part-costs/${id}`,
    method: 'post',
    data
  })
}

export const getPartCostOpChangeStates = (id, name) => {
  return axios.request({
    url: `operation-change-states/part-costs/${id}` + (name ? `?name=${name}` : ''),
    method: 'get'
  })
}
